const mEditionAssetSignedStudentsContents = {
  mEditionAssetSignedStudentsContents: {
    alerts: {
      activarContenidosAll: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'Todos los contenidos fueron activados exitosamente.'
      },
      desactivarContenidosAll: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'Todos los contenidos fueron desactivado exitosamente.'
      }
    },

    buttonSecondary: {
      text: 'Activar todos los contenidos'
    }
  }
}

export default mEditionAssetSignedStudentsContents
